<template>
  <div class="homeBox">
    <!--    banner     -->
    <div class="banner PurchaseBanner">
      <img src="../../public/img/pbg.png" alt="">
      <div class="softScript PurchaseSoftScript">
        <div class="TipText">
          <div class="title">企业采购</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            实现从供应商管理、询价、报价、合同签订、采购付款、收货、退货以及发票等<br/>
            规范	采购作业，实现采购全过程精细化管理。
          </div>
          <div class="start">
            <a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">
              开始吧
              <img src="../../public/img/right.png" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="SolveQuestion PurchaseQuestion">
      <div class="w1200">
        <div class="clearfix Sales">
          <div class="l">
            <img src="../../public/img/p1.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/picon1.png" alt="">
            </div>
            <div class="tip">
              待采购清单
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      可以直接创建询价单，并对询价单进行查看、
                      删除、分享链接等操作
                    </div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      可以从项目需求的源头控制项目的采购需求
                      与计划，每一个采购需求量都有据可依，减
                      少不合规的多采购或少采购的情况，从根本
                      上减少人为干预而导致的不必要的损失
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Progress">
          <div class="l">
            <img src="../../public/img/p2.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/picon2.png" alt="">
            </div>
            <div class="tip">
              我的询价单
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      发出询价单时，你选择的供应商将在此处
                      收到询价邀请。供应商可以查看询价的基
                      本信息。
                    </div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      询价开始后，可以查看到供应商的报价情况，
                      直接生成采购订单。也可以手动输入供应商
                      报价。通过该功能模块，可以直观的看到
                      询价的反馈情况。
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/p3.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/picon3.png" alt="">
            </div>
            <div class="tip">
              采购订单
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      从设计师上传bom清单自动生成采购需求，
                      让每一次采购都有据可依；同时采购预算可
                      与项目预算及控制系统关联，有效控制采购
                      成本；每笔采购可设置相对应的审批流程。
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Progress GetMetarial">
          <div class="l">
            <img src="../../public/img/p4.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/picon4.png" alt="">
            </div>
            <div class="tip">
              采购发票
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      相关权限人员可登记收/开发票票号、金额等
                      基础信息并可关联客户、合同及项目，系统
                      将自动归集与合同相关的所有开/收发票信息
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/p5.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/picon5.png" alt="">
            </div>
            <div class="tip">
              供应商
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      你可以利用全面、可靠的供应商信息视图，
                      简化供应商管理；利用集成式供应商资审和
                      细分流程，降低风险，避免任何不必要的开
                      支
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--提高效率，提高竞争力-->
    <div class="Increase PurchaseIncrease">
      <div class="w1200">
        <div class="TipText">
          <div class="title">提高效率，提高竞争力</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            让每个自动化企业都享受智慧服务与数据带来的改变
            <div class="bottomStart"><a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">开始吧<img src="../../public/img/right.png" alt=""></a></div>
          </div>
        </div>
      </div>
    </div>
    <!--导航  pc+mobile-->
    <Nav></Nav>
    <!--底部-->
    <Foot></Foot>
    <!--返回头部-->
    <GoTop></GoTop>
  </div>
</template>
<script>
  import Nav from '@/components/Nav.vue'
  import GoTop from '@/components/GoTop.vue'
  import Foot from '@/components/Foot.vue'
  export default {
    name: 'Purchase',
    data(){
      return {

      }
    },
    components: {
      Nav,
      GoTop,
      Foot
    },
    computed:{

    },
    methods:{

    },
    mounted(){

    },
    activated(){

    },
    created(){

    }
  }
</script>
<style>

</style>
